import React, { FC, ReactNode, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { CheckPicker } from 'rsuite';
import { RenderExtraFooter } from '../filter/RenderExtraFooter';
import { IPaymentGatewayItemProps } from '../merchants/paymentGateway/PaymentGatewayTableRow';
import { ISelectorData } from '../application/NewApplication';
import { usePaymentContext } from '../../store/payments/payments-context';
import {
	fetchProviderData,
	setPaymentGateway,
	setProviders,
} from '../../store/payments/actions/providers';

import './ProviderTableMultiSelector.scss';
import { useLocation } from 'react-router';
import { IProviderFiltersProps } from './ProviderFilters';
import { parseSearchParams } from '../../utils/utilities';

interface Props {
	title: string;
	value: string;
	id: string;
	fieldName: string;
	itemProps?: IPaymentGatewayItemProps;
	list: ISelectorData[];
}

export const ProviderTableMultiSelector: FC<Props> = (props) => {
	const { title, fieldName, value, id, itemProps, list } = props;
	const picker = useRef(null);
	const { search } = useLocation();

	const { dispatch } = usePaymentContext();

	const [cellValue, setCellValue] = useState<string>(value);
	const [currentCellValues, setCurrentCellValues] = useState<string[]>(value?.split(','));
	const [isClicked, setIsClicked] = useState<boolean>(false);

	const filtersFromUrl: IProviderFiltersProps = parseSearchParams(search);

	const allValues = list?.map(item => item.value);

	const handleCheckAll = (value, checked): void => {
		const selectedValues = checked ? allValues : [];
		setCurrentCellValues(selectedValues);
	};

	const handleSaveSelectedCardBrands = async (): Promise<void> => {
		picker.current?.close();
		if (itemProps) {
			const params = { ...itemProps };
			params.capabilities[fieldName] = currentCellValues.join(',');
			await setPaymentGateway(params);
		} else {
			const params = {
				id,
				capabilities: {
					[fieldName]: currentCellValues.join(',')
				}
			};
			await setProviders({ dispatch, params, fieldName });
			await fetchProviderData({ dispatch, searchParams: filtersFromUrl });
		}
		setCellValue(currentCellValues.join(','));
		setIsClicked(false);
	};

	// const onClose = ():void => {
	// 	setIsClicked(false);
	// 	setCurrentCellValues(cellValue.split(','));
	// };

	const cellMultiSelect = (
		<div className="d-flex">
			<div className="position-relative w-100">
				<CheckPicker
					data={list || []}
					ref={picker}
					value={currentCellValues}
					onChange={(value): void => setCurrentCellValues(value)}
					placeholder={title}
					className="provider-selector provider-checkpicker"
					appearance="subtle"
					placement="bottomEnd"
					cleanable={false}
					menuMaxHeight={325}
					// disabled={isTranslationDataLoading}
					renderExtraFooter={(): ReactNode => (
						<RenderExtraFooter
							statusFilter={currentCellValues}
							allValue={allValues}
							handleCheckAll={handleCheckAll}
							handleSave={handleSaveSelectedCardBrands}
						/>
					)}
				/>
			</div>
		</div>
	);

	return (
		<>
			{
				isClicked
					? cellMultiSelect
					: (
						<div
							className="fs-7 provider-cell cursor-pointer fc-text-overflow"
							onClick={(): void => {
								setIsClicked(true);
								picker.current?.open();
							}}
						>
							<FontAwesomeIcon icon={faPen} className="me-2 w-10px text-danger"/>
							{cellValue ? cellValue : '-'}
						</div>
					)
			}
		</>
	);
};
